/** @file Thai catalog part of area E7 (W3-03), partial; replaced whole by that area. */

/** The `shortcutsPanel`, `tokens`, `password` and `exportDialog` blocks (spread at the top level); partial, English fills the gaps. S0 composes it into `th`. */
export const settingsScreenTh = {
  shortcutsPanel: {
    hint: 'ปุ่มลัดอ้างอิงตำแหน่งปุ่มบนแป้นพิมพ์ จึงใช้ได้กับทุกเลย์เอาต์ รวมถึงภาษาไทย',
    unbound: 'ไม่ได้กำหนด', change: 'เปลี่ยน', unbind: 'ยกเลิกปุ่ม', reset: 'ค่าเริ่มต้น', resetAll: 'คืนค่าปุ่มลัดทั้งหมด',
    press: 'กดปุ่มใหม่… (Esc เพื่อยกเลิก)', capture: 'ปุ่มใหม่สำหรับ {id}',
    reserved: 'เบราว์เซอร์ไม่ส่ง {keys} ให้หน้าเว็บ เลือกปุ่มอื่น',
    conflict: '{keys} ถูกใช้แล้วโดย {other} ใน {context}', invalid: '{keys} ไม่ใช่ปุ่มลัดที่ถูกต้อง',
    action: {
      assetsDelete: 'ลบรูปที่เลือก', hierarchyDelete: 'ลบรายการที่เลือก', redoAlt: 'ทำซ้ำ (ปุ่มสำรอง)',
      curvesCancelGesture: 'ยกเลิกการลากเส้นโค้ง', timelinePlayPause: 'เล่นหรือหยุดชั่วคราว', timelineDeleteKeys: 'ลบคีย์ที่เลือก',
      timelineCopyKeys: 'คัดลอกคีย์ที่เลือก', timelinePasteKeys: 'วางคีย์ที่ตำแหน่งเพลย์เฮด', viewportCancel: 'ยกเลิกการทำงานที่กำลังลาก',
      viewportToggleMode: 'สลับระหว่าง Setup และ Animate', viewportToggleSnap: 'เปิดหรือปิดการดูด',
    },
  },
  tokens: {
    title: 'โทเคน API', hint: 'สร้างหนึ่งโทเคนต่อหนึ่งเอเจนต์ ชื่อโทเคนจะเป็นผู้ทำ (actor) ของทุก commit ที่มันทำ เพิกถอนแล้วถูกตัดทันที',
    name: 'ชื่อโทเคน', scopes: 'สิทธิ์', create: 'สร้างโทเคน', empty: 'ยังไม่มีโทเคน', revoke: 'เพิกถอน', confirmRevoke: 'คลิกอีกครั้งเพื่อเพิกถอน {name}',
    setup: 'ตั้งค่าไคลเอนต์', hideSetup: 'ซ่อนการตั้งค่า', meta: 'สร้าง {created} · ใช้ล่าสุด {used}', never: 'ยังไม่เคยใช้', revokedOn: 'เพิกถอนเมื่อ {date}',
    secretOnce: 'คัดลอกโทเคนตอนนี้ จะแสดงเพียงครั้งเดียว', done: 'เสร็จ', copy: 'คัดลอก', copied: 'คัดลอกแล้ว',
    configClaudeCode: 'Claude Code (.mcp.json)', configCodex: 'Codex (~/.codex/config.toml)', configEnv: 'ตัวแปรสภาพแวดล้อม (bash, PowerShell)',
    secretPlaceholder: '<token>',
  },
  password: {
    title: 'รหัสผ่าน', current: 'รหัสผ่านปัจจุบัน', next: 'รหัสผ่านใหม่', repeat: 'ยืนยันรหัสผ่านใหม่', submit: 'เปลี่ยนรหัสผ่าน',
    mismatch: 'รหัสผ่านใหม่ทั้งสองช่องไม่ตรงกัน', tooShort: 'ใช้อย่างน้อย {min} ตัวอักษร', wrongCurrent: 'รหัสผ่านปัจจุบันไม่ถูกต้อง',
    changed: 'เปลี่ยนรหัสผ่านแล้ว เบราว์เซอร์อื่นถูกออกจากระบบ',
  },
  exportDialog: {
    open: 'ส่งออก…', title: 'ส่งออก', close: 'ปิด', target: 'ปลายทาง', targetRig: 'Rig (zip สำหรับรันไทม์ Phaser และ Babylon)', targetSprites: 'สไปรต์ชีต',
    maxPage: 'ขนาดหน้าสูงสุด (px)', scale: 'สเกล', rigScale: 'สเกลเท็กซ์เจอร์ 1 = ขนาดเต็ม', fit: 'ย่อให้พอดีทุกเฟรม', padding: 'ระยะขอบ (px)', verify: 'ตรวจผลลัพธ์',
    animations: 'แอนิเมชัน', skins: 'สกิน', directions: 'ทิศทาง', allHint: 'รายการที่ไม่ได้ติ๊กอะไรจะส่งออกทั้งหมด',
    frameW: 'ความกว้างเฟรม', frameH: 'ความสูงเฟรม', fps: 'เฟรมต่อวินาที (0 = fps ของโปรเจกต์)', layout: 'การจัดวาง', layoutGrid: 'ตาราง',
    layoutPacked: 'อัดแน่น (เฟรมที่เหมือนกันใช้ช่องเดียว)', run: 'ส่งออก', running: 'กำลังส่งออก…', invalid: '{path}: {message}',
    ok: 'ส่งออกเสร็จ ไม่มีข้อผิดพลาด', failed: 'ส่งออกเสร็จ มีข้อผิดพลาด {n} รายการ', warnings: 'คำเตือน ({n})',
    warning: '{code}: {message} {path}', scaleUsed: 'สเกลพิกเซลที่ใช้: {scale}', files: 'ไฟล์',
  },
} as const;
